import { ChangeDetectorRef, Pipe, PipeTransform, effect, inject } from '@angular/core';
import { I18nService } from '../../core/services/i18n.service';

@Pipe({
  name: 't',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly i18n = inject(I18nService);
  private readonly changeDetector = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      this.i18n.language();
      this.changeDetector.markForCheck();
    });
  }

  transform(key: string, params: Record<string, string | number> = {}): string {
    return this.i18n.t(key, params);
  }
}
